import InputAdornment from '@material-ui/core/InputAdornment';

export default InputAdornment;
